/* eslint-disable */
import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { getGestionAtencion } from "../../services/ProduccionService";
import Message from "../../utils/Message";
//
// ###########################################################################
//
const DatosAccordion = (props) => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [data, setData] = useState({});
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosGestionAtencion = async () => {
      const response = await getGestionAtencion(props.idGestionAtencion, "header");

      if (response.ok) {
        setData(response.data.data);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadDatosGestionAtencion();
  }, []);
  //
  // ################################################################################
  //
  return (
    <>
      {data.codigo && (
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle1" sx={{ marginRight: 1 }}>
            Gestion de Atención {data.codigo} -
          </Typography>
          <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 'bold', marginRight: 1 }}>
            {data.nombre_cliente} {data.apellido_cliente}
          </Typography>
          <Typography variant="subtitle1" sx={{ marginRight: 1 }}>
            - {data.descripcion_area} -
          </Typography>
          <Typography variant="subtitle1" sx={{ marginRight: 1 }}>
            Registrada el {data.fecha_estado_gc} -
          </Typography>
          <Typography variant="subtitle1" sx={{ marginRight: 1 }}>
            Fecha de entrega: {data.fecha_entrega}
          </Typography>
          <Typography variant="subtitle1" sx={{ marginRight: 1 }}>
            - Vendedor {data.usuario_usuario}
          </Typography>
        </Box>
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};
export default DatosAccordion;
